import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FilterService } from 'src/app/services/filter.service';
import { AuthService } from 'src/app/services/auth.service';
import { CashDeskService } from 'src/app/services/cash-desk.service';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { AdmissionService } from '../../../services/admission.service';

@Component({
  selector: 'app-caller-filter',
  templateUrl: './caller-filter.component.html',
  styleUrls: ['./caller-filter.component.css']
})
export class CallerFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;

  constructor(private formBuilder: FormBuilder
    , private admissionService: AdmissionService
    , private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      Name: ['']
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('CallerFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('CallerFilterComponent', this.form);
  }

  async search(): Promise<any> {
    return await this.admissionService.getCallerSearchItem(this.form.controls.Name.value);
  }

  async ngOnInit() {

  }
}
